// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { Emit_main } from "../navigation"
import * as P from "../program-state"
import * as C from "../controls"
import {useForm, Controller} from "react-hook-form"
import { faBan, faPlus } from '@fortawesome/free-solid-svg-icons'
import { General_preview_component, preview_data_t } from "./campaigns/common"
import { useNavigate, useParams } from 'react-router-dom'
import { creative_schema_t } from "./resource/types"
import {z} from "zod"
import {linkedin_bid_suggestion_t} from "../resource/types"
import {linkedin_bid_suggestion_payload_t, get_linkedin_bid_suggestion} from "./campaigns/common"
import {Audience_widget_horizontal} from "./audiences-individual-editor"


type Edit_campaign_form_data = {
    name: string;
    headline: string;
    message: string;
    link: string;
    file_id: number;
    audience_id: number;
    // optional fields
    meta_budget: number;
    meta_bid_amount: number;

    linkedin_budget: number;
    linkedin_bid_amount: number;

    tiktok_budget: number;
    tiktok_bid_amount: number;
}

interface smart_creative_t {
    file_id: number;
    name: string;
    headline: string;
    message: string;
    link: string;
    audience_id: number;
  }
  
  interface facebook_config_t {
    budget: number;
    bid_amount: number;
  }
  
  interface linkedin_config_t {
    budget: number;
    bid_amount: number;
    conversion_tracking_id: number;
  }
  
  interface tiktok_config_t {
    budget: number;
    bid_amount: number;
    video_id: number;
  }
  
  interface edit_campaign_payload_t {
    smart_creative: smart_creative_t;
    facebook_config?: facebook_config_t;
    linkedin_config?: linkedin_config_t;
    tiktok_config?: tiktok_config_t;
  }


const map_creative_fields_to_form_fields = (creative : creative_schema_t) => {
    const { linkedin_config, facebook_config, tiktok_config } = creative

    return {
        name: creative.name,
        headline: creative.headline,
        message: creative.message,
        link: creative.link,
        file_id: creative.file_id,
        audience_id: creative.audience_id,

        meta_budget: facebook_config ? facebook_config.budget : 0,
        meta_bid_amount: facebook_config ? facebook_config.bid_amount : 0,

        linkedin_budget: linkedin_config ? linkedin_config.budget : 0,
        linkedin_bid_amount: linkedin_config ? linkedin_config.bid_amount : 0,
        // linkedin_conversion_tracking_id: linkedin_config ? linkedin_config.conversion_tracking_id : 0,
        tiktok_budget: tiktok_config ? tiktok_config.budget : 0,
        tiktok_bid_amount: tiktok_config ? tiktok_config.bid_amount : 0
    }
}


const Edit_campaign_form = ({creative} : {creative : creative_schema_t}) => {
    console.log("/i/ Editing the creative: ", creative)
    const nav = useNavigate()
    const [ps, cs] = P.use_authenticated_program_state()
    const [saved_audiences] = P.use_saved_audiences()
    const [linkedin_budget_suggestion, set_linkedin_budget_suggestion] = useState<linkedin_bid_suggestion_t | null>(null);
    const { linkedin_config, facebook_config, tiktok_config } = creative
    const [file_detail, set_file_detail] = useState<any>(null)

    const fetch_file_detail = async (file_id : number) => {
        const [Ok, resp] = await P.issue_json_get(P.v1api`media/files/${file_id}?direct=false`, z.any(), cs.token)
        if (Ok) {
            set_file_detail(resp)
        } else {
            console.error(resp)
        }
    }

    P.run_once_on_component_creation(() => {
        void P.poll_saved_audiences(ps, cs)
    })

    useEffect(()=> {
        fetch_file_detail(creative.file_id)
    }, [creative.file_id])

    const { register, setValue, watch, control, formState: { errors }, setError, clearErrors } = useForm<Edit_campaign_form_data>(
        {defaultValues: map_creative_fields_to_form_fields(creative)}
    )

    const audiences_data = !!saved_audiences ? saved_audiences.map((a) => {
        return {key: String(a.id), display: a.name}
    }) : []

    const submit_the_form = async () => {
        const form_data = watch()
        let payload : edit_campaign_payload_t = {
            smart_creative: {
                name: form_data.name,
                headline: form_data.headline,
                message: form_data.message,
                link: form_data.link,
                file_id: form_data.file_id,
                // when the first time loading form, if user havent touch the audience_id,
                // fall to the default audience_id
                audience_id: form_data.audience_id || creative.smart_campaign.audience_id
            }
        }

        if (facebook_config) {
            payload.facebook_config = {
                budget: form_data.meta_budget,
                bid_amount: form_data.meta_bid_amount
            }
        }

        if (linkedin_config) {
            payload.linkedin_config = {
                budget: form_data.linkedin_budget,
                bid_amount: form_data.linkedin_bid_amount
            }
        }

        if (tiktok_config) {
            payload.tiktok_config = {
                budget: form_data.tiktok_budget,
                bid_amount: form_data.tiktok_bid_amount
            }
        }


        const [ok, resp] = await P.issue_json_put(P.v1api`smart-campaign/campaigns/${creative.id}`, payload, z.any(), cs.token)

        if (ok) {
            nav("/campaigns")
        } else {
            console.log("Failed", resp)
        }
    }

    const validate_linkedin_bid = (bid_amount: number) => {
        let suggested_bid = linkedin_budget_suggestion?.suggestedBid?.min?.amount
        if (suggested_bid && Number(bid_amount) < suggested_bid) {
            setError("linkedin_bid_amount", {type: "manual", message: `Suggested bid amount is ${suggested_bid}`})
        } else {
            clearErrors("linkedin_bid_amount")
        }
    }

    const audience_id_watcher = watch('audience_id');

    watch(async (data, { name, type }) => {
        if (name === "audience_id") {
            console.log("Audience on changes: ", data, name, type)
            let payload : linkedin_bid_suggestion_payload_t = {
                objective: creative.smart_campaign.objective,
                brand_id: creative.smart_campaign.brand.id,
                audience_id: data.audience_id,
                budget: data.linkedin_budget
            }

            const bid_suggestion : linkedin_bid_suggestion_t | null = await get_linkedin_bid_suggestion(cs.token, payload)
            console.log("/i/ Bid suggestion: ", bid_suggestion)
            set_linkedin_budget_suggestion(bid_suggestion)

            validate_linkedin_bid(data.linkedin_bid_amount)
        }

        if (name === "linkedin_bid_amount") {
            validate_linkedin_bid(data["linkedin_bid_amount"])
        }
    })

    const form_data_to_preview = () : preview_data_t => {
        const data = watch()
        return {
            name: data.name,
            headline: data.headline,
            message: data.message,
            link: data.link,
            file_id: data.file_id,
            audience_id: data.audience_id,
            meta_budget: data.meta_budget,
            meta_bid_amount: data.meta_bid_amount,
            linkedin_budget: data.linkedin_budget,
            linkedin_bid_amount: data.linkedin_bid_amount,
            tiktok_budget: data.tiktok_budget,
            tiktok_bid_amount: data.tiktok_bid_amount
        }
    }

    const handle_file_change = async (event : React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (file) {
            const formData = new FormData();
            formData.append('fileb', file);
            const [ok, resp] = await P.issue_formdata_post(P.v1api`media/files/`, formData, z.any(), cs.token)

            if (ok) {
                setValue("file_id", resp.id)
            } else {
                console.log("Failed", resp)
            }
        }
    }

    return (
        <>
            <C.Eres_bare_card className="tw-mb-6">
                <div className='tw-flex tw-items-center tw-justify-between'>
                    <div>
                        <C.Eres_header2xl className="tw-font-semibold">Edit an existing campaign</C.Eres_header2xl>
                        <p>Use the below form to update your existing running campaign.</p>
                    </div>
                    <div className='tw-flex-shrink-0 tw-space-x-2'>
                        <C.Eres_iconbutton icon={faBan} onClick={() => {nav("/campaigns")}}>Cancel</C.Eres_iconbutton>
                        <C.Eres_iconbutton id="f-save" icon={faPlus} onClick={submit_the_form} >Update campaign</C.Eres_iconbutton>
                    </div>
                </div>
            </C.Eres_bare_card>

            <div className='tw-mb-2'></div>
            <C.Eres_card >
                <div className="tw-p-3">
                <div className='tw-flex tw-flex-row tw-space-x-2'>
                    <div className='tw-w-1/2'>
                        <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                            <C.Eres_form_label htmlFor="eres-audience-name">Creative name</C.Eres_form_label>
                            <C.Eres_line_edit id="eres-audience-name" aria-label="name" type="text" disabled extra={register("name")} />
                            <C.Eres_form_label htmlFor="eres-headline">Headline</C.Eres_form_label>
                            <C.Eres_line_edit id="eres-headline" aria-label="name" type="text" extra={register("headline")} />

                            <C.Eres_form_label htmlFor="eres-audience-message">Message</C.Eres_form_label>
                            <textarea rows={4} className={`tw-transition tw-m-0 tw-text-black tw-font-normal tw-text-base ${C.form_element_styles}`} {...register("message")}  />

                            <C.Eres_form_label htmlFor="eres-audience-link">Link</C.Eres_form_label>
                            <C.Eres_line_edit id="eres-audience-link" aria-label="name" extra={register("link")} />

                            <C.Eres_form_label htmlFor="eres-audience-media">Media</C.Eres_form_label>
                            <div>
                                <C.Eres_file_input on_change={handle_file_change} default_file_name={file_detail?.file_name} />
                                <div className="tw-mt-1 tw-text-sm tw-text-gray-500 tw-dark:text-gray-300" id="user_avatar_help">A media can be an image or video to be used as your media for ad</div>
                            </div>

                            <C.Eres_form_label htmlFor="eres-brand">Audience</C.Eres_form_label>
                            <div className='tw-overflow-hidden'>
                                <Controller name="audience_id" control={control} render={({field}) => (
                                    <C.Eres_combobox
                                        id="e_audience_id"
                                        data={audiences_data}
                                        defaultValue={audiences_data.length ? audiences_data[0].key : undefined}
                                        search_placeholder="Search for an audience ..."
                                        empty_selection_text="No audience selected"
                                        unselect_placeholder="Don't use an audience"
                                        no_matches_placeholder="No matching audiences"
                                        {...field}
                                    />
                                )}/>
                                <C.Eres_collapse title="View audience detail">
                                    <Audience_widget_horizontal audience_id={audience_id_watcher} />
                                </C.Eres_collapse>
                            </div>
                            <C.Eres_hline />
                            <C.Eres_hline />
                            {
                                facebook_config &&
                                    <>
                                        <C.Eres_form_label>Facebook specific config</C.Eres_form_label>
                                        <div>
                                            <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                                                <C.Eres_form_label htmlFor="eres-fb-budget">Budget</C.Eres_form_label>
                                                <C.Eres_line_edit id="eres-fb-budget" aria-label="name" type="text" extra={register("meta_budget")} />
                                                <C.Eres_form_label htmlFor="eres-fb-bid-amount">Bid amount</C.Eres_form_label>
                                                <C.Eres_line_edit id="eres-fb-bid-amount" type="text" extra={register("meta_bid_amount")} />
                                            </div>
                                        </div>
                                    </>
                            }
                            {
                            facebook_config && <>
                                <C.Eres_hline />
                                <C.Eres_hline />
                            </> }
                            {
                                linkedin_config && 
                                <>
                                    <C.Eres_form_label>Linkedin specific config</C.Eres_form_label>
                                    <div>
                                        <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                                            <C.Eres_form_label htmlFor="eres-tt-budget">Budget</C.Eres_form_label>
                                            <C.Eres_line_edit id="eres-li-budget" aria-label="name" type="text" extra={register("linkedin_budget")} />
                                            <C.Eres_form_label htmlFor="eres-li-bid-amount">Bid amount</C.Eres_form_label>
                                            <div>
                                                <C.Eres_line_edit id="eres-li-bid-amount" type="text" extra={register("linkedin_bid_amount")} />
                                                { (errors.linkedin_bid_amount && errors.linkedin_bid_amount.message) && <C.Eres_form_error className="tw-mt-0" msg={errors.linkedin_bid_amount.message} /> }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                (facebook_config || linkedin_config) && <>
                                    <C.Eres_hline />
                                    <C.Eres_hline />
                                </>
                            }
                            {
                                tiktok_config &&
                                <>
                                    <C.Eres_form_label>Tiktok specific config</C.Eres_form_label>
                                    <div>
                                        <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                                            <C.Eres_form_label htmlFor="eres-tt-budget">Budget</C.Eres_form_label>
                                            <C.Eres_line_edit id="eres-tt-budget" aria-label="name" type="text" extra={register("tiktok_budget")} />
                                            <C.Eres_form_label htmlFor="eres-tt-bid-amount">Bid amount</C.Eres_form_label>
                                            <C.Eres_line_edit id="eres-tt-bid-amount" type="text" extra={register("tiktok_bid_amount")} />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                    <div className='tw-w-1/2'>
                        <General_preview_component networks={creative?.smart_campaign.networks} preview_data={form_data_to_preview()} />
                    </div>
                </div>
                </div>
            </C.Eres_card>
        </>
    )
}


const Edit_creative: React.FC = () => {
    const { prefixed_dbid } = useParams()
    const [active_creative, set_active_creative] = useState<creative_schema_t | null>(null);
    const [creatives, ps, cs] = P.use_creatives()

    P.run_once_on_component_creation(() => {
        void P.poll_creatives(ps, cs)
    })

    useEffect(() => {
        let found_creative = P.get_creative(creatives, prefixed_dbid)
        set_active_creative(found_creative)
    }, [creatives])

    return (
        <Emit_main page_id="PAGE-campaigns">
            {active_creative ? <Edit_campaign_form creative={active_creative} /> : <C.Eres_spin_placeholder className="tw-p-6"/> }
        </Emit_main>
    )
};

export default Edit_creative;
